export const KYC_STATUS_VARIANTS = {
  BANK_VERIFIED: "BANK_VERIFIED",
  PAN_NOT_SUBMITTED: "PAN_NOT_SUBMITTED",
  PAN_VERIFIED: "PAN_VERIFIED",
  VERIFIED: "VERIFIED",
  PENDING: "PENDING",
  VERIFIED_NOT_SUBMITTED: "VERIFIED_NOT_SUBMITTED",
  GST_VERIFICATION_PENDING: "GST_VERIFICATION_PENDING",
  GST_VERIFIED: "GST_VERIFIED",
};
